import { useSelector } from 'react-redux';
import { useIsLoading } from 'new/hooks/adapters/useIsLoading';
import { GET_RESOURCE_FILES_REQUEST } from 'js/constants/actionTypes';
import has from 'lodash/has';
import { FILES_PAGINATED } from 'js/constants/paginationEntitiesTypes';
import Constants from 'js/Constants';

const { IngestionStatus } = Constants;

export type ResourceStatsFile = {
  dataSetId: number;
  dataSourceId: number;
  error: string;
  errorCount: number;
  ingestionStatus: keyof typeof IngestionStatus;
  lastIngested: string;
  lastModified: string;
  metadata: any;
  name: string;
  recordCount: number;
  size: number;
};

type Result = {
  items: ResourceStatsFile[];
  meta: {
    currentPage: number;
    totalCount: number;
    pageCount: number;
    orderBy: string;
    status: string;
  };
  loading: boolean;
};

export function useResourceStatsFiles(type, id): Result {
  const data = useSelector((state: any) => state?.pagination?.data);
  const loading = useIsLoading(GET_RESOURCE_FILES_REQUEST);

  if (has(data, [FILES_PAGINATED, type, id, 'metrics'])) {
    const metrics = data[FILES_PAGINATED][type][id]?.metrics;
    const meta = metrics?.meta;
    const items = metrics?.data;
    return { items, meta, loading };
  }
  // @ts-ignore
  return { items: [], meta: {}, loading };
}
